/**
 * This file is created manually
 * You can change the content
 *
 */

import Ingress from './typography/Ingress'
export * from './typography/Ingress'
export default Ingress
